// extracted by mini-css-extract-plugin
export default {"side-navigation-menu":"footer_side-navigation-menu__aYvrv","menu-footer":"footer_menu-footer__OoOJf","footer":"footer_footer__M8fZa"};